const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/sandboxes/$id/offers.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { validateSandboxCatalogSearch } from "@/lib/sandbox-catalog";
import { sandboxCatalogQueryOptions } from "@/queries/sandbox-catalog";
import { getQueryClient } from "@/lib/client";
import { getFetchedQuery } from "@/lib/get-fetched-query";
import { generateSandboxMeta } from "@/lib/generate-sandbox-meta";
import i18n from "@/lib/i18n";
export const Route = createFileRoute("/{-$locale}/sandboxes/$id/offers")({
  validateSearch: validateSandboxCatalogSearch,
  loaderDeps: ({
    search
  }) => search,
  loader: async ({
    context,
    params,
    deps
  }) => {
    await context.queryClient.prefetchQuery(sandboxCatalogQueryOptions(params.id, deps, context.country || "US"));
    return {
      id: params.id,
      dehydratedState: dehydrate(context.queryClient)
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  head: ctx => {
    const {
      params
    } = ctx;
    const queryClient = getQueryClient();
    if (!ctx.loaderData) {
      return {
        meta: [{
          title: i18n.t("sandboxes.notFoundTitle"),
          description: i18n.t("sandboxes.notFoundDescription")
        }]
      };
    }
    const {
      id
    } = params;
    const sandbox = getFetchedQuery<SingleSandbox>(queryClient, ctx.loaderData?.dehydratedState, ["sandbox", {
      id
    }]);
    const offer = getFetchedQuery<SingleOffer>(queryClient, ctx.loaderData?.dehydratedState, ["sandbox", "base-game", {
      id
    }]);
    if (!sandbox) return {
      meta: [{
        title: i18n.t("sandboxes.notFoundTitle"),
        description: i18n.t("sandboxes.notFoundDescription")
      }]
    };
    return {
      meta: generateSandboxMeta(sandbox, offer, i18n.t("sandboxes.metaOffersTitle"))
    };
  }
});